import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React, { useState } from 'react';
import { AssetResourceType } from '../../../interfaces';
import { Icon } from '../../../subkit-ui';
import { serviceCustomerCreated, subscriptionCreated } from '../../../utils/segmentAnalytics';
import { stripeErrorHandler } from '../../../utils/stripe';
import TWServiceProfileLayout from '../../TWServiceProfileLayout/TWServiceProfileLayout.container';
import ExistingCardForm from '../ExistingCardForm.container';
import NewCardForm from '../NewCardForm.container';
import { OrderSummary } from './OrderSummary';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PaymentStepComponent = function PaymentStepComponent(_ref) {
  var _providerService$prov;

  var plan = _ref.plan,
      order = _ref.order,
      cardOnFile = _ref.cardOnFile,
      redirectURL = _ref.redirectURL,
      initOrderPayment = _ref.initOrderPayment,
      createSubscription = _ref.createSubscription,
      verifyPayment = _ref.verifyPayment,
      getServiceCustomersByUserIdAndServiceId = _ref.getServiceCustomersByUserIdAndServiceId,
      createBooking = _ref.createBooking,
      getOrder = _ref.getOrder,
      updateOrder = _ref.updateOrder;
  var providerService = plan.providerService;

  var _useState = useState(null),
      error = _useState[0],
      setError = _useState[1];

  var _useState2 = useState(false),
      forgetPaymentDetails = _useState2[0],
      setForgetPaymentDetails = _useState2[1];

  var paymentDetails;

  if (order.paymentDetails) {
    paymentDetails = order.paymentDetails;
  } else if (cardOnFile) {
    paymentDetails = {
      paymentMethod: cardOnFile.id,
      type: cardOnFile.brand,
      last4: cardOnFile.last4
    };
  }

  var handleCreateSubscription = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(subscriptionOrder, receiveEmails) {
      var _plan$invoicePreview, _plan$invoicePreview$;

      var assetsToFinalize, newSubscription, id;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              assetsToFinalize = subscriptionOrder.includedAssets || [];
              _context2.next = 3;
              return createSubscription({
                planId: plan.id,
                orderId: subscriptionOrder.id,
                receiveEmails: receiveEmails,
                options: {
                  shouldRedirect: assetsToFinalize.length ? false : true,
                  redirectTo: redirectURL
                },
                // TODO: figure out a way to determine stripe promo code was applied to show discount applied here
                successNotificationText: (_plan$invoicePreview = plan.invoicePreview) !== null && _plan$invoicePreview !== void 0 && (_plan$invoicePreview$ = _plan$invoicePreview.lines) !== null && _plan$invoicePreview$ !== void 0 && _plan$invoicePreview$.reduce(function (acc, next) {
                  return acc || next.amount < 0;
                }, false) ? 'Subscription Created. Your discount has been applied!' : 'Subscription Created'
              });

            case 3:
              newSubscription = _context2.sent;

              if (newSubscription) {
                assetsToFinalize.forEach( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(a) {
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.t0 = a.resourceType;
                            _context.next = _context.t0 === AssetResourceType.SESSION ? 3 : 5;
                            break;

                          case 3:
                            _context.next = 5;
                            return createBooking({
                              serviceId: providerService.id,
                              sessionId: a.resourceId,
                              orderId: order.id,
                              attendees: 1
                            });

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x3) {
                    return _ref3.apply(this, arguments);
                  };
                }());
                id = newSubscription.id;
                subscriptionCreated({
                  id: id,
                  plan: plan,
                  providerService: providerService
                });
              }

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleCreateSubscription(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var onCreateToken = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(receiveEmails, token) {
      var initiatedOrder, serviceCustomerId;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return initOrderPayment({
                planId: plan.id,
                orderId: order.id
              }, token);

            case 3:
              initiatedOrder = _context3.sent;
              _context3.next = 10;
              break;

            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](0);
              setError(_context3.t0);
              return _context3.abrupt("return");

            case 10:
              _context3.prev = 10;
              _context3.next = 13;
              return confirmPayment(initiatedOrder.paymentDetails, initiatedOrder.status);

            case 13:
              _context3.next = 19;
              break;

            case 15:
              _context3.prev = 15;
              _context3.t1 = _context3["catch"](10);
              setError(_context3.t1);
              return _context3.abrupt("return");

            case 19:
              _context3.next = 21;
              return handleCreateSubscription(initiatedOrder, receiveEmails);

            case 21:
              _context3.next = 23;
              return getServiceCustomersByUserIdAndServiceId(order === null || order === void 0 ? void 0 : order.user.id, providerService.id);

            case 23:
              serviceCustomerId = _context3.sent;
              serviceCustomerId && serviceCustomerCreated({
                user: serviceCustomerId,
                serviceId: providerService === null || providerService === void 0 ? void 0 : providerService.id,
                providerServices: providerService,
                serviceType: 'Plan subscription'
              });

            case 25:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 6], [10, 15]]);
    }));

    return function onCreateToken(_x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }();

  var confirmPayment = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(finalPaymentDetails, status) {
      var serviceStripe, result;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(status === 'succeeded')) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return");

            case 2:
              _context4.next = 4;
              return loadStripe(process.env.NEXT_PUBLIC_STRIPE_KEY, {
                stripeAccount: plan.providerService.paymentPlatformId
              });

            case 4:
              serviceStripe = _context4.sent;
              _context4.next = 7;
              return serviceStripe.confirmCardPayment(finalPaymentDetails.clientSecret, {
                payment_method: finalPaymentDetails.paymentMethod
              });

            case 7:
              result = _context4.sent;

              if (result.error) {
                stripeErrorHandler(result.error);
              } // Poll the server to make sure stripe webhooks updated the order and marked it a success


              _context4.next = 11;
              return verifyPayment();

            case 11:
              return _context4.abrupt("return", result.paymentIntent);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function confirmPayment(_x6, _x7) {
      return _ref5.apply(this, arguments);
    };
  }();

  var onConfirmPayment = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(receiveEmails) {
      var initiatedOrder, serviceCustomerId;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;

              if (!order.paymentDetails) {
                _context5.next = 6;
                break;
              }

              _context5.next = 4;
              return confirmPayment(order.paymentDetails, order.status);

            case 4:
              _context5.next = 11;
              break;

            case 6:
              _context5.next = 8;
              return initOrderPayment({
                planId: plan.id,
                orderId: order.id
              });

            case 8:
              initiatedOrder = _context5.sent;
              _context5.next = 11;
              return confirmPayment(initiatedOrder.paymentDetails, initiatedOrder.status);

            case 11:
              _context5.next = 13;
              return handleCreateSubscription(order, receiveEmails);

            case 13:
              _context5.next = 15;
              return getServiceCustomersByUserIdAndServiceId(order === null || order === void 0 ? void 0 : order.user.id, providerService.id);

            case 15:
              serviceCustomerId = _context5.sent;
              serviceCustomerId && serviceCustomerCreated({
                user: serviceCustomerId,
                serviceId: providerService === null || providerService === void 0 ? void 0 : providerService.id,
                providerServices: providerService,
                serviceType: 'Plan subscription'
              });
              return _context5.abrupt("return", true);

            case 20:
              _context5.prev = 20;
              _context5.t0 = _context5["catch"](0);
              setError(_context5.t0);
              return _context5.abrupt("return", false);

            case 24:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 20]]);
    }));

    return function onConfirmPayment(_x8) {
      return _ref6.apply(this, arguments);
    };
  }();

  var buttonText = plan.trial_period_days && !order.invoicePreview.switchingPlan ? 'Confirm Free Trial' : 'Confirm Recurring Payment';

  if (order.invoicePreview.scheduledDowngrade) {
    buttonText = 'Confirm Change';
  }

  var icon = order.invoicePreview.total ? 'lock' : 'check';
  return /*#__PURE__*/_jsx(TWServiceProfileLayout, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "max-w-full lg:max-w-screen-xl lg:mx-auto p-4",
      children: [/*#__PURE__*/_jsxs("a", {
        href: "/".concat(providerService === null || providerService === void 0 ? void 0 : (_providerService$prov = providerService.provider) === null || _providerService$prov === void 0 ? void 0 : _providerService$prov.slug),
        className: "flex text-gray-500 text-base font-medium no-underline mb-2",
        children: [/*#__PURE__*/_jsx(Icon, {
          name: "angle-left",
          type: "regular",
          className: "text-xl"
        }), /*#__PURE__*/_jsxs("span", {
          className: "block ml-2 text-base",
          children: ["Back to ", providerService === null || providerService === void 0 ? void 0 : providerService.name]
        })]
      }), /*#__PURE__*/_jsx("h1", {
        className: "font-serif text-3xl m-0 ws-pre-line mt-3 capitalize",
        children: "Subscribe"
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex justify-between mt-4 flex-col-reverse md:flex-row",
        children: [/*#__PURE__*/_jsx("div", {
          className: "w-full mt-8 md:w-1/2 md:pr-2.5 xl:pr-24 md:mt-0",
          children: !error && paymentDetails && !forgetPaymentDetails ? /*#__PURE__*/_jsx(ExistingCardForm, {
            serverError: error,
            paymentDetails: paymentDetails,
            providerService: providerService,
            serviceAccountId: providerService.paymentPlatformId,
            onConfirmPayment: onConfirmPayment,
            buttonText: buttonText,
            icon: icon,
            order: order,
            getOrder: getOrder,
            updateOrder: updateOrder,
            isSubscription: true,
            setForgetPaymentDetails: setForgetPaymentDetails
          }) : /*#__PURE__*/_jsx(NewCardForm, {
            serverError: error,
            providerService: providerService,
            serviceAccountId: providerService.paymentPlatformId,
            onCreateToken: onCreateToken,
            buttonText: buttonText,
            icon: icon,
            order: order,
            getOrder: getOrder,
            updateOrder: updateOrder,
            isSubscription: true
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "w-full md:w-1/2 md:pl-2.5 xl:pl-24",
          children: /*#__PURE__*/_jsx(OrderSummary, {
            order: order,
            plan: plan
          })
        })]
      })]
    })
  });
};

var PaymentStep = function PaymentStep(props) {
  // Initiate stripe on the Subkit level for the card form
  var stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_KEY);
  return /*#__PURE__*/_jsx(Elements, {
    stripe: stripePromise,
    children: /*#__PURE__*/_jsx(PaymentStepComponent, _objectSpread({}, props))
  });
};

export default PaymentStep;